import request from '@/utils/request.js'
import { handleFormData } from '@/utils/index'

export function getadvList(data) {
    return request.get('/api/H5/home/getadvList', {
        params: data,
        noLoading: true
    })
}

export function getSysConfig(data) {
    return request.get('/api/H5/home/getSysConfig', {
        params: data,
        noLoading: true
    })
}

export function getagreement(data) {
    return request.get('/api/H5/home/getagreement', {
        params: data
    })
}

export function uploadFile(data) {
    return request.post('/api/admin/Upload/UploadFile', handleFormData(data))
}

export function gethelpdoclist(data) {
    return request.get('/api/H5/home/gethelpdoclist', {
        params: data,
        noLoading: true
    })
}

export function getbocpaylist(data) {
    return request.get('/api/H5/home/getbocpaylist', {
        params: data,
        noLoading: true
    })
}

export function gethelpdocbyid(data) {
    return request.get('/api/H5/home/gethelpdocbyid', {
        params: data,
        noLoading: true
    })
}

export function getbottomdoclist(data) {
    return request.get('/api/H5/home/getbottomdoclist', {
        params: data,
        noLoading: true
    })
}

export function sendmsg(data) {
    return request.get('/api/H5/home/sendmsg', {
        params: data
    })
}
export function getarealist(data) {
    return request.get('/api/H5/vendingmachine/getarealist', {
        params: data
    })
}


export function getdicdtabykey(data) {
    return request.get('/api/admin/sysdicdata/getdicdtabykey', {
        params: data
    })
}

export function gethomenotelist(data) {
    return request.get('/api/H5/home/gethomenotelist', {
        params: data
    })
}
